// theme.js
const theme = {
    colors: {
      text: '#000',
      background: '#fff',
      modes: {
        dark: {
          text: '#fff',
          background: '#242424',
        },
      },
    },
  };
  
  export default theme;
  